import { Row, Col, } from 'react-bootstrap';
import { LazyLoadImage } from "react-lazy-load-image-component";
import CardShop from "./cardShop";


const Separator = (props) => {

    const { segment_title, banner, shops } = props.data.item;


    return (
        <div className="mt-4">
            {
                segment_title !== '' ?
                <Row>
                    <Col className="cat-header">
                        {segment_title}
                    </Col>
                </Row>
                :''
            }

            {
                banner !== null ?
                <Row className="mt-2">
                    <LazyLoadImage className="w-100"  src={banner} alt={segment_title} />
                </Row>
                :''
            }

            {
                shops.map((item, key) => {
                    return(
                        <CardShop data={{item}} key={key} />
                    );
                })
            }
        </div>
    );
}

export default Separator;